/**
 * Block deprecation
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-deprecation/
 * @see https://developer.wordpress.org/news/2023/03/block-deprecation-a-tutorial/
 */

import {
  useBlockProps,
  useInnerBlocksProps
} from '@wordpress/block-editor';

const v6 = {
  supports: {
    html: false,
    lock: false
  },
  attributes: {
    ctaSlideText: {
      default: [],
      type: 'array'
    },
    ctaLinkUrl: {
      default: '',
      type: 'string'
    },
    ctaLinkTarget: {
      default: false,
      type: 'boolean'
    },
    allowedMetadataFields: {
      default: [],
      type: 'array'
    },
    allowedContributorRoles: {
      default: [],
      type: 'array'
    },
    innerBlocksAttrs: {
      default: [],
      type: 'array'
    },
    parentAttrs: {
      default: {},
      type: 'object'
    }
  },
  save({ attributes }) {
    const {
      ctaSlideText,
      ctaLinkUrl,
      ctaLinkTarget,
      allowedMetadataFields,
      allowedContributorRoles,
      innerBlocksAttrs,
      parentAttrs
    } = attributes;

    const linkObj = {
      text: ctaSlideText.length > 0 ? ctaSlideText.toString() : undefined,
      href: ctaLinkUrl || undefined,
      target: ctaLinkTarget || undefined
    };

    const checkLinkObjValues = Object.values( linkObj );
    const linkObjIsUndefined = checkLinkObjValues.every( ( item ) => item === undefined );
    const jsonLink = !linkObjIsUndefined ? JSON.stringify( linkObj ) : null;

    const dataModule = parentAttrs?.isCarousel ? 'carousel' : 'grid';
    const dataAllowedMetadataFields = parentAttrs?.featureBy === 'books' ? JSON.stringify( allowedMetadataFields ) : null;
    const dataAllowedContributorRoles = parentAttrs?.featureBy === 'contributors' && allowedContributorRoles.length > 0 ? JSON.stringify( allowedContributorRoles ) : null;
    const dataManualData = innerBlocksAttrs?.length ? JSON.stringify( innerBlocksAttrs ) : null;
    const dataSortBy = parentAttrs?.featureBy === 'books' ? 'onsale' : 'authorLast';
    const dataDir = parentAttrs?.featureBy === 'books' ? 'desc' : 'asc';

    const blockProps = useBlockProps.save({
      className: `block__list`
    });

    // Manual list
    const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
      className: 'inner-blocks-wrapper relative',
      'data-feature-by': parentAttrs.featureBy,
      'data-show-metadata': parentAttrs.showMetadata,
      'data-allowed-metadata-fields': dataAllowedMetadataFields,
      'data-allowed-contributor-roles': dataAllowedContributorRoles,
      'data-entry': 'manual',
      'data-list-type': 'small-list',
      'data-module': dataModule,
      'data-cta': jsonLink,
      'data-manual-data': dataManualData
    });

    /**
      * Handle additional logic
      */

    /**
      * Handle element styles
      */

    /**
      * Handle element classes
      */

    return (
      <div { ...blockProps }>

        <div className='list--inner'>

          {/* Automatic book list */}
          { parentAttrs?.filterBy !== 'custom' && (
            <div
              className='inner-blocks-wrapper relative'
              data-feature-by={ parentAttrs?.featureBy ? parentAttrs.featureBy : null }
              data-filter-by={ parentAttrs?.filterBy ? parentAttrs.filterBy : null }
              data-division-code={ parentAttrs?.divisionCode ? parentAttrs.divisionCode : null }
              data-imprint-code={ parentAttrs?.imprintCode ? parentAttrs.imprintCode : null }
              data-series-code={ parentAttrs?.seriesCode ? parentAttrs.seriesCode : null }
              data-bisac-code={ parentAttrs?.bisacCode ? parentAttrs.bisacCode : null }
              data-category-code={ parentAttrs?.categoryCode ? parentAttrs.categoryCode : null }
              data-age-range-code={ parentAttrs?.ageRangeCode ? parentAttrs.ageRangeCode : null }
              data-collection-isbns={ parentAttrs?.collectionISBNs ? parentAttrs.collectionISBNs : null }
              data-brand-code={ parentAttrs?.brandCode ? parentAttrs.brandCode : null }
              data-theme-code={ parentAttrs?.themeCode ? parentAttrs.themeCode : null }
              data-selected-formats={ parentAttrs?.selectedFormats?.length > 0 ? JSON.stringify( parentAttrs.selectedFormats ) : null }
              data-selected-languages={ parentAttrs?.selectedLanguages?.length > 0 ? JSON.stringify( parentAttrs.selectedLanguages ) : null }
              data-sort-by={ dataSortBy }
              data-direction={ dataDir }
              data-show-metadata={ parentAttrs.showMetadata }
              data-allowed-metadata-fields={ dataAllowedMetadataFields }
              data-allowed-contributor-roles={ dataAllowedContributorRoles }
              data-show-covers={ parentAttrs.featureBy === 'books' && parentAttrs.showCovers ? true : null }
              data-hide-award-winners={ parentAttrs.featureBy === 'books' && parentAttrs.hideAwardWinners ? true : null }
              data-show-breadcrumb={ parentAttrs.showBreadcrumb }
              data-hide-authors-with-no-photo={ parentAttrs.featureBy === 'contributors' && parentAttrs.showCovers ? true : null }
              data-entry='automatic'
              data-list-type={ parentAttrs?.isFilters ? 'full-list' : 'small-list' }
              data-module={ dataModule }
              data-cta={ jsonLink }
            >
            </div>
          ) }

          {/* Manual book list */}
          { parentAttrs?.filterBy === 'custom' && (
            <div { ...innerBlocksProps }>

              {/* Hide to prevent flash of content */}
              <div className='hidden'>
                { children }
              </div>

            </div>
          ) }

        </div>

      </div>
    );
  }
};

const v5 = {
  supports: {
    html: false,
    lock: false
  },
  attributes: {
    ctaSlideText: {
      default: [],
      type: 'array'
    },
    ctaLinkUrl: {
      default: '',
      type: 'string'
    },
    ctaLinkTarget: {
      default: false,
      type: 'boolean'
    },
    allowedMetadataFields: {
      default: [],
      type: 'array'
    },
    allowedContributorRoles: {
      default: [],
      type: 'array'
    },
    innerBlocksAttrs: {
      default: [],
      type: 'array'
    },
    parentAttrs: {
      default: {},
      type: 'object'
    }
  },
  save({ attributes }) {
    const {
      ctaSlideText,
      ctaLinkUrl,
      ctaLinkTarget,
      allowedMetadataFields,
      allowedContributorRoles,
      innerBlocksAttrs,
      parentAttrs
    } = attributes;

    const linkObj = {
      text: ctaSlideText.length > 0 ? ctaSlideText.toString() : undefined,
      href: ctaLinkUrl || undefined,
      target: ctaLinkTarget || undefined
    };

    const checkLinkObjValues = Object.values( linkObj );
    const linkObjIsUndefined = checkLinkObjValues.every( ( item ) => item === undefined );
    const jsonLink = !linkObjIsUndefined ? JSON.stringify( linkObj ) : null;

    const dataModule = parentAttrs?.isCarousel ? 'carousel' : 'grid';
    const dataAllowedMetadataFields = parentAttrs?.featureBy === 'books' ? JSON.stringify( allowedMetadataFields ) : null;
    const dataAllowedContributorRoles = parentAttrs?.featureBy === 'contributors' && allowedContributorRoles.length > 0 ? JSON.stringify( allowedContributorRoles ) : null;
    const dataManualData = innerBlocksAttrs?.length ? JSON.stringify( innerBlocksAttrs ) : null;
    const dataSortBy = parentAttrs?.featureBy === 'books' ? 'onsale' : 'authorLast';
    const dataDir = parentAttrs?.featureBy === 'books' ? 'desc' : 'asc';

    const blockProps = useBlockProps.save({
      className: `block__list`
    });

    const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
      className: 'inner-blocks-wrapper relative',
      'data-feature-by': parentAttrs.featureBy,
      'data-show-metadata': parentAttrs.showMetadata,
      'data-allowed-metadata-fields': dataAllowedMetadataFields,
      'data-allowed-contributor-roles': dataAllowedContributorRoles,
      'data-entry': 'manual',
      'data-list-type': 'small-list',
      'data-module': dataModule,
      'data-cta': jsonLink,
      'data-manual-data': dataManualData
    });

    return (
      <div { ...blockProps }>
        <div className='list--inner'>
          { parentAttrs?.filterBy !== 'custom' && (
            <div
              className='inner-blocks-wrapper relative'
              data-feature-by={ parentAttrs?.featureBy ? parentAttrs.featureBy : null }
              data-filter-by={ parentAttrs?.filterBy ? parentAttrs.filterBy : null }
              data-division-code={ parentAttrs?.divisionCode ? parentAttrs.divisionCode : null }
              data-imprint-code={ parentAttrs?.imprintCode ? parentAttrs.imprintCode : null }
              data-series-code={ parentAttrs?.seriesCode ? parentAttrs.seriesCode : null }
              data-category-code={ parentAttrs?.categoryCode ? parentAttrs.categoryCode : null }
              data-age-range-code={ parentAttrs?.ageRangeCode ? parentAttrs.ageRangeCode : null }
              data-brand-code={ parentAttrs?.brandCode ? parentAttrs.brandCode : null }
              data-selected-formats={ parentAttrs?.selectedFormats?.length > 0 ? JSON.stringify( parentAttrs.selectedFormats ) : null }
              data-selected-languages={ parentAttrs?.selectedLanguages?.length > 0 ? JSON.stringify( parentAttrs.selectedLanguages ) : null }
              data-sort-by={ dataSortBy }
              data-direction={ dataDir }
              data-show-metadata={ parentAttrs.showMetadata }
              data-allowed-metadata-fields={ dataAllowedMetadataFields }
              data-allowed-contributor-roles={ dataAllowedContributorRoles }
              data-show-covers={ parentAttrs.featureBy === 'books' && parentAttrs.showCovers ? true : null }
              data-hide-award-winners={ parentAttrs.featureBy === 'books' && parentAttrs.hideAwardWinners ? true : null }
              data-show-breadcrumb={ parentAttrs.showBreadcrumb }
              data-hide-authors-with-no-photo={ parentAttrs.featureBy === 'contributors' && parentAttrs.showCovers ? true : null }
              data-entry='automatic'
              data-list-type={ parentAttrs?.isFilters ? 'full-list' : 'small-list' }
              data-module={ dataModule }
              data-cta={ jsonLink }
            >
            </div>
          ) }
          { parentAttrs?.filterBy === 'custom' && (
            <div { ...innerBlocksProps }>
              <div className='hidden'>
                { children }
              </div>

            </div>
          ) }

        </div>

      </div>
    );
  }
};

const v4 = {
  supports: {
    html: false,
    lock: false
  },
  attributes: {
    ctaSlideText: {
      default: [],
      type: 'array'
    },
    ctaLinkUrl: {
      default: '',
      type: 'string'
    },
    ctaLinkTarget: {
      default: false,
      type: 'boolean'
    },
    allowedMetadataFields: {
      default: [],
      type: 'array'
    },
    allowedContributorRoles: {
      default: [],
      type: 'array'
    },
    innerBlocksAttrs: {
      default: [],
      type: 'array'
    },
    parentAttrs: {
      default: {},
      type: 'object'
    }
  },
  save({ attributes }) {
    const {
      ctaSlideText,
      ctaLinkUrl,
      ctaLinkTarget,
      allowedMetadataFields,
      allowedContributorRoles,
      innerBlocksAttrs,
      parentAttrs
    } = attributes;

    const linkObj = {
      text: ctaSlideText.length > 0 ? ctaSlideText.toString() : undefined,
      href: ctaLinkUrl || undefined,
      target: ctaLinkTarget || undefined
    };

    const checkLinkObjValues = Object.values( linkObj );
    const linkObjIsUndefined = checkLinkObjValues.every( ( item ) => item === undefined );
    const jsonLink = !linkObjIsUndefined ? JSON.stringify( linkObj ) : null;

    const dataModule = parentAttrs?.isCarousel ? 'carousel' : 'grid';
    const dataAllowedMetadataFields = parentAttrs?.featureBy === 'books' ? JSON.stringify( allowedMetadataFields ) : null;
    const dataAllowedContributorRoles = parentAttrs?.featureBy === 'contributors' && allowedContributorRoles.length > 0 ? JSON.stringify( allowedContributorRoles ) : null;
    const dataManualData = innerBlocksAttrs?.length ? JSON.stringify( innerBlocksAttrs ) : null;
    const dataSortBy = parentAttrs?.featureBy === 'books' ? 'onsale' : 'authorLast';
    const dataDir = parentAttrs?.featureBy === 'books' ? 'desc' : 'asc';

    const blockProps = useBlockProps.save({
      className: `block__list`
    });

    // Manual list
    const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
      className: 'inner-blocks-wrapper relative',
      'data-feature-by': parentAttrs.featureBy,
      'data-show-metadata': parentAttrs.showMetadata,
      'data-allowed-metadata-fields': dataAllowedMetadataFields,
      'data-allowed-contributor-roles': dataAllowedContributorRoles,
      'data-entry': 'manual',
      'data-list-type': 'small-list',
      'data-module': dataModule,
      'data-cta': jsonLink,
      'data-manual-data': dataManualData
    });

    return (
      <div { ...blockProps }>
        <div className='list--inner'>
          {/* Automatic book list */}
          { parentAttrs?.filterBy !== 'custom' && (
            <div
              className='inner-blocks-wrapper relative'
              data-feature-by={ parentAttrs?.featureBy ? parentAttrs.featureBy : null }
              data-filter-by={ parentAttrs?.filterBy ? parentAttrs.filterBy : null }
              data-division-code={ parentAttrs?.divisionCode ? parentAttrs.divisionCode : null }
              data-imprint-code={ parentAttrs?.imprintCode ? parentAttrs.imprintCode : null }
              data-series-code={ parentAttrs?.seriesCode ? parentAttrs.seriesCode : null }
              data-category-code={ parentAttrs?.categoryCode ? parentAttrs.categoryCode : null }
              data-age-range-code={ parentAttrs?.ageRangeCode ? parentAttrs.ageRangeCode : null }
              data-selected-formats={ parentAttrs?.selectedFormats?.length > 0 ? JSON.stringify( parentAttrs.selectedFormats ) : null }
              data-selected-languages={ parentAttrs?.selectedLanguages?.length > 0 ? JSON.stringify( parentAttrs.selectedLanguages ) : null }
              data-sort-by={ dataSortBy }
              data-direction={ dataDir }
              data-show-metadata={ parentAttrs.showMetadata }
              data-allowed-metadata-fields={ dataAllowedMetadataFields }
              data-allowed-contributor-roles={ dataAllowedContributorRoles }
              data-show-covers={ parentAttrs.featureBy === 'books' && parentAttrs.showCovers ? true : null }
              data-show-breadcrumb={ parentAttrs.showBreadcrumb }
              data-hide-authors-with-no-photo={ parentAttrs.featureBy === 'contributors' && parentAttrs.showCovers ? true : null }
              data-entry='automatic'
              data-list-type={ parentAttrs?.isFilters ? 'full-list' : 'small-list' }
              data-module={ dataModule }
              data-cta={ jsonLink }
            >
            </div>
          ) }
          {/* Manual book list */}
          { parentAttrs?.filterBy === 'custom' && (
            <div { ...innerBlocksProps }>
              {/* Hide to prevent flash of content */}
              <div className='hidden'>
                { children }
              </div>
            </div>
          ) }

        </div>
      </div>
    );
  }
};

const v3 = {
  supports: {
    html: false,
    lock: false
  },
  attributes: {
    ctaSlideText: {
      default: [],
      type: 'array'
    },
    ctaLinkUrl: {
      default: '',
      type: 'string'
    },
    ctaLinkTarget: {
      default: false,
      type: 'boolean'
    },
    allowedMetadataFields: {
      default: [],
      type: 'array'
    },
    allowedContributorRoles: {
      default: [],
      type: 'array'
    },
    innerBlocksAttrs: {
      default: [],
      type: 'array'
    },
    parentAttrs: {
      default: {},
      type: 'object'
    }
  },
  save({ attributes }) {
    const {
      ctaSlideText,
      ctaLinkUrl,
      ctaLinkTarget,
      allowedMetadataFields,
      allowedContributorRoles,
      innerBlocksAttrs,
      parentAttrs
    } = attributes;

    const linkObj = {
      text: ctaSlideText.length > 0 ? ctaSlideText.toString() : undefined,
      href: ctaLinkUrl || undefined,
      target: ctaLinkTarget || undefined
    };

    const checkLinkObjValues = Object.values( linkObj );
    const linkObjIsUndefined = checkLinkObjValues.every( ( item ) => item === undefined );
    const jsonLink = !linkObjIsUndefined ? JSON.stringify( linkObj ) : null;

    const dataModule = parentAttrs?.isCarousel ? 'carousel' : 'grid';
    const dataAllowedMetadataFields = parentAttrs?.featureBy === 'books' ? JSON.stringify( allowedMetadataFields ) : null;
    const dataAllowedContributorRoles = parentAttrs?.featureBy === 'contributors' && allowedContributorRoles.length > 0 ? JSON.stringify( allowedContributorRoles ) : null;
    const dataManualData = innerBlocksAttrs?.length ? JSON.stringify( innerBlocksAttrs ) : null;
    const dataSortBy = parentAttrs?.featureBy === 'books' ? 'onsale' : 'authorLast';
    const dataDir = parentAttrs?.featureBy === 'books' ? 'desc' : 'asc';

    const blockProps = useBlockProps.save({
      className: `block__list`
    });

    // Manual list
    const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
      className: 'inner-blocks-wrapper relative',
      'data-feature-by': parentAttrs.featureBy,
      'data-show-metadata': parentAttrs.showMetadata,
      'data-allowed-metadata-fields': dataAllowedMetadataFields,
      'data-allowed-contributor-roles': dataAllowedContributorRoles,
      'data-entry': 'manual',
      'data-list-type': 'small-list',
      'data-module': dataModule,
      'data-cta': jsonLink,
      'data-manual-data': dataManualData
    });

    return (
      <div { ...blockProps }>
        <div className='list--inner'>
          {/* Automatic book list */}
          { parentAttrs?.filterBy !== 'custom' && (
            <div
              className='inner-blocks-wrapper relative'
              data-feature-by={ parentAttrs?.featureBy ? parentAttrs.featureBy : null }
              data-filter-by={ parentAttrs?.filterBy ? parentAttrs.filterBy : null }
              data-division-code={ parentAttrs?.divisionCode ? parentAttrs.divisionCode : null }
              data-imprint-code={ parentAttrs?.imprintCode ? parentAttrs.imprintCode : null }
              data-series-code={ parentAttrs?.seriesCode ? parentAttrs.seriesCode : null }
              data-category-code={ parentAttrs?.categoryCode ? parentAttrs.categoryCode : null }
              data-age-range-code={ parentAttrs?.ageRangeCode ? parentAttrs.ageRangeCode : null }
              data-selected-formats={ parentAttrs?.selectedFormats ? JSON.stringify( parentAttrs.selectedFormats ) : null }
              data-selected-languages={ parentAttrs?.selectedLanguages?.length > 0 ? JSON.stringify( parentAttrs.selectedLanguages ) : null }
              data-sort-by={ dataSortBy }
              data-direction={ dataDir }
              data-show-metadata={ parentAttrs.showMetadata }
              data-allowed-metadata-fields={ dataAllowedMetadataFields }
              data-allowed-contributor-roles={ dataAllowedContributorRoles }
              data-show-covers={ parentAttrs.featureBy === 'books' && parentAttrs.showCovers ? true : null }
              data-show-breadcrumb={ parentAttrs.showBreadcrumb }
              data-hide-authors-with-no-photo={ parentAttrs.featureBy === 'contributors' && parentAttrs.showCovers ? true : null }
              data-entry='automatic'
              data-list-type={ parentAttrs?.isFilters ? 'full-list' : 'small-list' }
              data-module={ dataModule }
              data-cta={ jsonLink }
            >
            </div>
          ) }
          {/* Manual book list */}
          { parentAttrs?.filterBy === 'custom' && (
            <div { ...innerBlocksProps }>
              {/* Hide to prevent flash of content */}
              <div className='hidden'>
                { children }
              </div>
            </div>
          ) }

        </div>
      </div>
    );
  }
};

const v2 = {
  supports: {
    html: false,
    lock: false
  },
  attributes: {
    ctaSlideText: {
      default: [],
      type: 'array'
    },
    ctaLinkUrl: {
      default: '',
      type: 'string'
    },
    ctaLinkTarget: {
      default: false,
      type: 'boolean'
    },
    allowedMetadataFields: {
      default: [],
      type: 'array'
    },
    allowedContributorRoles: {
      default: [],
      type: 'array'
    },
    innerBlocksAttrs: {
      default: [],
      type: 'array'
    },
    parentAttrs: {
      default: {},
      type: 'object'
    }
  },
  save({ attributes }) {
    const {
      ctaSlideText,
      ctaLinkUrl,
      ctaLinkTarget,
      allowedMetadataFields,
      allowedContributorRoles,
      innerBlocksAttrs,
      parentAttrs
    } = attributes;

    const linkObj = {
      text: ctaSlideText.length > 0 ? ctaSlideText.toString() : undefined,
      href: ctaLinkUrl || undefined,
      target: ctaLinkTarget || undefined
    };

    const checkLinkObjValues = Object.values( linkObj );
    const linkObjIsUndefined = checkLinkObjValues.every( ( item ) => item === undefined );
    const jsonLink = !linkObjIsUndefined ? JSON.stringify( linkObj ) : null;

    const dataModule = parentAttrs?.isCarousel ? 'carousel' : 'grid';
    const dataAllowedMetadataFields = parentAttrs?.featureBy === 'books' ? JSON.stringify( allowedMetadataFields ) : null;
    const dataAllowedContributorRoles = parentAttrs?.featureBy === 'contributors' && allowedContributorRoles.length > 0 ? JSON.stringify( allowedContributorRoles ) : null;
    const dataManualData = innerBlocksAttrs?.length ? JSON.stringify( innerBlocksAttrs ) : null;
    const dataSortBy = parentAttrs?.featureBy === 'books' ? 'onsale' : 'authorLast';
    const dataDir = parentAttrs?.featureBy === 'books' ? 'desc' : 'asc';

    const blockProps = useBlockProps.save({
      className: `block__list`
    });

    // Manual list
    const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
      className: 'inner-blocks-wrapper relative',
      'data-feature-by': parentAttrs.featureBy,
      'data-show-metadata': parentAttrs.showMetadata,
      'data-allowed-metadata-fields': dataAllowedMetadataFields,
      'data-allowed-contributor-roles': dataAllowedContributorRoles,
      'data-entry': 'manual',
      'data-list-type': 'small-list',
      'data-module': dataModule,
      'data-cta': jsonLink,
      'data-manual-data': dataManualData
    });

    return (
      <div { ...blockProps }>
        <div className='list--inner'>
          {/* Automatic book list */}
          { parentAttrs?.filterBy !== 'custom' && (
            <div
              className='inner-blocks-wrapper relative'
              data-feature-by={ parentAttrs?.featureBy ? parentAttrs.featureBy : null }
              data-filter-by={ parentAttrs?.filterBy ? parentAttrs.filterBy : null }
              data-division-code={ parentAttrs?.divisionCode ? parentAttrs.divisionCode : null }
              data-imprint-code={ parentAttrs?.imprintCode ? parentAttrs.imprintCode : null }
              data-series-code={ parentAttrs?.seriesCode ? parentAttrs.seriesCode : null }
              data-category-code={ parentAttrs?.categoryCode ? parentAttrs.categoryCode : null }
              data-age-range-code={ parentAttrs?.ageRangeCode ? parentAttrs.ageRangeCode : null }
              data-selected-formats={ parentAttrs?.selectedFormats ? JSON.stringify( parentAttrs.selectedFormats ) : null }
              data-selected-languages={ parentAttrs?.selectedLanguages?.length > 0 ? JSON.stringify( parentAttrs.selectedLanguages ) : null }
              data-sort-by={ dataSortBy }
              data-direction={ dataDir }
              data-show-metadata={ parentAttrs.showMetadata }
              data-allowed-metadata-fields={ dataAllowedMetadataFields }
              data-allowed-contributor-roles={ dataAllowedContributorRoles }
              data-show-covers={ parentAttrs.featureBy === 'books' && parentAttrs.showCovers ? true : null }
              data-hide-authors-with-no-photo={ parentAttrs.featureBy === 'contributors' && parentAttrs.showCovers ? true : null }
              data-entry='automatic'
              data-list-type={ parentAttrs?.isFilters ? 'full-list' : 'small-list' }
              data-module={ dataModule }
              data-cta={ jsonLink }
            >
            </div>
          ) }
          {/* Manual book list */}
          { parentAttrs?.filterBy === 'custom' && (
            <div { ...innerBlocksProps }>
              {/* Hide to prevent flash of content */}
              <div className='hidden'>
                { children }
              </div>
            </div>
          ) }

        </div>
      </div>
    );
  }
};

const v1 = {
  supports: {
    html: false,
    lock: false
  },
  attributes: {
    ctaSlideText: {
      default: [],
      type: 'array'
    },
    ctaLinkUrl: {
      default: '',
      type: 'string'
    },
    ctaLinkTarget: {
      default: false,
      type: 'boolean'
    },
    allowedMetadataFields: {
      default: [],
      type: 'array'
    },
    allowedContributorRoles: {
      default: [],
      type: 'array'
    },
    innerBlocksAttrs: {
      default: [],
      type: 'array'
    },
    parentAttrs: {
      default: {},
      type: 'object'
    }
  },
  save({ attributes }) {
    const {
      ctaSlideText,
      ctaLinkUrl,
      ctaLinkTarget,
      allowedMetadataFields,
      allowedContributorRoles,
      innerBlocksAttrs,
      parentAttrs
    } = attributes;

    const linkObj = {
      text: ctaSlideText.length > 0 ? ctaSlideText.toString() : undefined,
      href: ctaLinkUrl || undefined,
      target: ctaLinkTarget || undefined
    };

    const checkLinkObjValues = Object.values( linkObj );
    const linkObjIsUndefined = checkLinkObjValues.every( ( item ) => item === undefined );
    const jsonLink = !linkObjIsUndefined ? JSON.stringify( linkObj ) : null;

    const dataModule = parentAttrs?.isCarousel ? 'carousel' : 'grid';
    const dataAllowedMetadataFields = parentAttrs?.featureBy === 'books' ? JSON.stringify( allowedMetadataFields ) : null;
    const dataAllowedContributorRoles = parentAttrs?.featureBy === 'contributors' && allowedContributorRoles.length > 0 ? JSON.stringify( allowedContributorRoles ) : null;
    const dataManualData = innerBlocksAttrs?.length ? JSON.stringify( innerBlocksAttrs ) : null;
    const dataSortBy = parentAttrs?.featureBy === 'books' ? 'onsale' : 'authorLast';
    const dataDir = parentAttrs?.featureBy === 'books' ? 'desc' : 'asc';

    const blockProps = useBlockProps.save({
      className: `block__list`
    });

    // Manual list
    const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
      className: 'inner-blocks-wrapper relative',
      'data-feature-by': parentAttrs.featureBy,
      'data-show-metadata': parentAttrs.showMetadata,
      'data-allowed-metadata-fields': dataAllowedMetadataFields,
      'data-allowed-contributor-roles': dataAllowedContributorRoles,
      'data-entry': 'manual',
      'data-list-type': 'small-list',
      'data-module': dataModule,
      'data-cta': jsonLink,
      'data-manual-data': dataManualData
    });

    return (
      <div { ...blockProps }>
        <div className='list--inner'>
          {/* Automatic book list */}
          { parentAttrs?.filterBy !== 'custom' && (
            <div
              className='inner-blocks-wrapper relative'
              data-feature-by={ parentAttrs?.featureBy ? parentAttrs.featureBy : null }
              data-filter-by={ parentAttrs?.filterBy ? parentAttrs.filterBy : null }
              data-division-code={ parentAttrs?.divisionCode ? parentAttrs.divisionCode : null }
              data-imprint-code={ parentAttrs?.imprintCode ? parentAttrs.imprintCode : null }
              data-series-code={ parentAttrs?.seriesCode ? parentAttrs.seriesCode : null }
              data-category-code={ parentAttrs?.categoryCode ? parentAttrs.categoryCode : null }
              data-age-range-code={ parentAttrs?.ageRangeCode ? parentAttrs.ageRangeCode : null }
              data-sort-by={ dataSortBy }
              data-direction={ dataDir }
              data-show-metadata={ parentAttrs.showMetadata }
              data-allowed-metadata-fields={ dataAllowedMetadataFields }
              data-allowed-contributor-roles={ dataAllowedContributorRoles }
              data-show-covers={ parentAttrs.featureBy === 'books' && parentAttrs.showCovers ? true : null }
              data-hide-authors-with-no-photo={ parentAttrs.featureBy === 'contributors' && parentAttrs.showCovers ? true : null }
              data-entry='automatic'
              data-list-type={ parentAttrs?.isFilters ? 'full-list' : 'small-list' }
              data-module={ dataModule }
              data-cta={ jsonLink }
            >
            </div>
          ) }
          {/* Manual book list */}
          { parentAttrs?.filterBy === 'custom' && (
            <div { ...innerBlocksProps }>
              {/* Hide to prevent flash of content */}
              <div className='hidden'>
                { children }
              </div>
            </div>
          ) }

        </div>
      </div>
    );
  }
};

export default [ v6, v5, v4, v3, v2, v1 ];
